export class WinFieldConstants {
	public static readonly SCALE_TO_FIT_BOX: number = 0.35;
	public static readonly SCALING_TO_VALUE: number = 0.5;
	public static readonly WIN_NUMBER_FONT_NAME: string = 'SMALL_';
	public static readonly CURRENCY_FONT_NAME: string = 'MED_';
}


// WEBPACK FOOTER //
// ./src/winfield/WinFieldConstants.ts